import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Convenio, FuncaoService, Login, Pagamento, PagamentoResto } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';
import { tsXLXS } from 'ts-xlsx-export';
import { PagamentoRestoService } from '../../../tesouraria/pagamento-resto/service/pagamento-resto.service';
import { PagamentoService } from '../../../tesouraria/pagamento/service/pagamento.service';
import { EmpenhoRestoService } from 'contabil-lib';
import { EmpenhoService } from 'administrativo-lib';

@Component({
  selector: 'lib-convenio-pagamento',
  templateUrl: './convenio-pagamento.component.html',
})
export class ConvenioPagamentoComponent implements OnInit, OnChanges, OnDestroy {

  protected unsubscribe: Subject<void> = new Subject();

  public listaPags: Array<any> = [];
  public pagamentos: any;
  public pagamentosResto: any;

  @Input() convenio: Convenio;
  @Input() login: Login;

  public paginaCorrente: number = 1;
  public paginaTotal: number;
  public limite: number = 20;
  public pagamentosVisualizacao = []

  constructor(
    protected confirmationService: ConfirmationService,
    protected funcaoService: FuncaoService,
    protected pagamentoService: PagamentoService,
    protected pagamentoRestoService: PagamentoRestoService,
    protected empenhoRestoService: EmpenhoRestoService,
    protected empenhoService: EmpenhoService
  ) { }

  ngOnInit() {
    this.buscarPagamentos();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  async ngOnChanges(changes: SimpleChanges) {
  }

  public exportarXLSX() {
    const listaItens = new Array();
    for (const item of this.listaPags) {
      const entity = {
        exercicio: item.exercicio.ano,
        empenho: item.liquidacao.empenho.numero,
        parcela: item.liquidacao.parcela > 0 ? item.liquidacao.parcela : '',
        data_pagamento: this.funcaoService.converteDataBR(item.data_pagamento),
        documento: item.documento,
        conta_bancaria: `${item.conta.banco.nome} ${item.conta.agencia} ${item.conta.numero_conta}`,
        recurso: `${item.conta_recurso?.recurso.codigo}.${item.conta_recurso?.aplicacao.codigo}`,
        valor_pago: item.valor_pago
      };
      listaItens.push(entity);
    }
    tsXLXS().exportAsExcelFile(listaItens).saveAsExcelFile(`pagamentos - ${this.convenio.numero} ${this.convenio.ano}`);
  }

  public async proximaPagina() {
    if (this.paginaCorrente < this.paginaTotal) {
      this.paginaCorrente++;
      await this.buscarPagamentos();
      window.scrollTo(0, 0);
    }
  }

  public async paginaAnterior() {
    this.paginaCorrente = this.paginaCorrente === 1 ? 1 : this.paginaCorrente - 1;
    await this.buscarPagamentos();
    window.scrollTo(0, 0);
  }

  public async paginaDigitada(pagina: number) {
    this.paginaCorrente = pagina >= this.paginaTotal ? this.paginaTotal : pagina;
    await this.buscarPagamentos();
    window.scrollTo(0, 0);
  }

  public async mudarLimite(limite: number) {
    this.limite = limite;
    this.paginaDigitada(1);
    await this.buscarPagamentos();
  }

  public preencherPagVisualizacao() {
    const inicio = (this.paginaCorrente - 1) * this.limite;
    const fim = inicio + this.limite;
    this.pagamentosVisualizacao = this.listaPags.slice(inicio, fim);
  }

  public async buscarPagamentos(pagina: number = this.paginaCorrente) {

    this.pagamentosResto = await this.pagamentoRestoService.filtrar(pagina, this.limite, { 'liquidacao.empenho.convenio.id': this.convenio.id, 'ignoreCondObrig': true, 'relations': 'exercicio,liquidacao.empenho,conta.banco' }).toPromise();

    this.pagamentos = await this.pagamentoService.filtrar(pagina, this.limite, { 'liquidacao.empenho.convenio.id': this.convenio.id, 'ignoreCondObrig': true, 'relations': 'exercicio,liquidacao.empenho,conta.banco,conta_recurso.aplicacao,conta_recurso.recurso' }).toPromise()

    for (const item of this.pagamentos.content) {
      this.listaPags.push(item);
    }

    for (const item of this.pagamentosResto.content) {
      this.listaPags.push(item);
    }

    this.paginaTotal = +this.pagamentosResto.totalPages + +this.pagamentos.totalPages;
    this.preencherPagVisualizacao();
  }
}
